import { Poll } from '../../../db/polls/types';
import { ToBeDone } from '../../../db/types';
import { getIsActivityPublished, getIsManuallyClosedActivity } from '../../../utils/activities';
import { unix } from '../../../utils/datetime';

export function getCanPublishPoll(poll: Poll | null) {
  if (!poll) return false;

  const isPollPublished = getIsActivityPublished(poll);
  return !isPollPublished;
}

export function getIsPollPublishable(
  poll: Poll | null,
  scheduledStartTime: UnixTime | undefined,
  scheduledEndTime: UnixTime | undefined
) {
  if (!poll) return false;

  if (!scheduledStartTime) return false;
  if (!scheduledEndTime) return false;

  if (poll.toBeDone === ToBeDone.PRE_CLASS) {
    const thirtyMinutes = 30 * 60;
    const thirtyMinutesBeforeScheduledStartTime = scheduledStartTime - thirtyMinutes;
    return unix() < thirtyMinutesBeforeScheduledStartTime;
  }

  return unix() > scheduledStartTime && unix() < scheduledEndTime;
}

export function getIsScheduledEndTimeInPast(scheduledEndTime?: UnixTime) {
  if (!scheduledEndTime) return false;
  return unix() >= scheduledEndTime;
}

export function getIsPollPublished(poll: Poll | null) {
  if (!poll) return false;

  const isPollPublished = getIsActivityPublished(poll);
  return isPollPublished;
}

export function getIsPollOpen(poll: Poll | null) {
  if (!poll) return false;

  const isPollDueDateTimeInFuture = poll.dueDateTime > unix();
  if (isPollDueDateTimeInFuture) return true;

  const isPollManual = getIsManuallyClosedActivity(poll);
  const isDueDateTimeManual = isPollManual && poll.dueDateTime <= 0;

  return isDueDateTimeManual;
}

export function getCanStopPoll(poll: Poll | null) {
  if (!poll) return false;

  if (poll.toBeDone !== ToBeDone.IN_CLASS) return false;

  const isPollManual = getIsManuallyClosedActivity(poll);
  const isDueDateTimeManual = isPollManual && poll.dueDateTime <= 0;

  return isDueDateTimeManual;
}
